export default __webpack_public_path__ + "e4f5ad1578e3a96e75f67a063509bee0.svg";